import { useCallback, useState } from 'react'

export type UseSwitchBinder = {
  isChecked: boolean
  toggle: (value?: boolean) => void
  reset: () => void
}

export function useSwitch(defaultValue: boolean = false): UseSwitchBinder {
  const [isChecked, setIsChecked] = useState<boolean>(defaultValue)

  const toggle = useCallback((value?: boolean) => {
    if (typeof value === 'boolean') {
      setIsChecked(value)
    } else {
      setIsChecked((prev) => !prev)
    }
  }, [])

  return {
    isChecked,
    toggle,
    reset: () => setIsChecked(defaultValue),
  }
}
